import { DerivedEventTypeLegacy, GrammarDerivedEventTypeLegacy } from '@verantos-dev/types-cohorts';

export const transformDerivedEventTypeToGrammarValue = (
  derivedEventType?: DerivedEventTypeLegacy
): string => {
  switch (derivedEventType) {
    case DerivedEventTypeLegacy.INSTANCE:
      return GrammarDerivedEventTypeLegacy.INSTANCE;
    case DerivedEventTypeLegacy.MERGED:
      return GrammarDerivedEventTypeLegacy.MERGED;
    case DerivedEventTypeLegacy.SEQUENCE:
      return GrammarDerivedEventTypeLegacy.SEQUENCE;
    default:
      throw new Error(`Cannot submit without a derived event type`);
  }
};
